export enum SupportedLocales {
	en = "en",
	ja = "ja"
}
